import { render, staticRenderFns } from "./editSeller.vue?vue&type=template&id=2917988f&"
import script from "./editSeller.vue?vue&type=script&lang=js&"
export * from "./editSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports